import _typeof from "@babel/runtime/helpers/typeof";
import { DateInputRole } from "../interfaces";
export var getRangePickerAltText = function getRangePickerAltText(altTextParam, inputRole) {
  if (_typeof(altTextParam) !== 'object') {
    return altTextParam;
  }

  return inputRole === DateInputRole.StartDate ? altTextParam.startDate : altTextParam.endDate;
};